/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { StoredMessageResponseUiPartsItem } from './storedMessageResponseUiPartsItem';

export interface StoredMessageResponse {
  id: string;
  role: string;
  ui_parts: StoredMessageResponseUiPartsItem[];
  created_at: string;
}
